import * as React from "react";
import { Component } from "react";
import MainLayout from "../../layouts/MainLayout";
import Table from "../../components/Table";
import {__, getLocalized, getURLParam, mapStateToProps, setTableParams} from "../../core/utils";
import { createSuperadminSidebar } from "../../redux/actions/general/sidebar";
import { listActiveModules } from "../../redux/actions/general/active_modules";
import Tooltip from "../../components/Tooltip";
import * as _ from "lodash";
import { setPlusActions } from "../../redux/actions/general/plus";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import { hideAlertbox, showAlertbox } from "../../redux/actions/general/alertbox";
import { setNotification } from "../../redux/actions/general/notification";
import {
	deleteBuildingTypes,
	listBuildingTypes,
	readBuildingType
} from "../../redux/actions/table/superadmin/building_types";
import BuildingTypesFlyout from "../../flyouts/superadmin/building_types/BuildingTypesFlyout";
import TableNA from "../../components/TableNA";

@mapStateToProps(state => ({
	superadmin: state.auth.superadmin,
	table: state.table["superadmin_building_types"],
	application_language_id: state.auth.language_id,
}))
class BuildingTypes extends Component {
	constructor(props) {
		super(props);

		this.state = {
			preview: null,
		};
	}

	componentDidMount() {
		listActiveModules();
		createSuperadminSidebar(); //don't forget to add new routes in sidebar.js

		const { superadmin } = this.props;

		superadmin.add_building_type && setPlusActions([{
			title: "Add building type",
			onClick: () => setTableParams('superadmin_building_types', {
				add_building_type_wizard: true
			})
		}]);
	}

	componentDidUpdate(prevProps) {
		if (this.props.table.clicked_row && this.props.table.clicked_row !== prevProps.table.clicked_row) {
			if (!prevProps.table.clicked_row) {
				this.setState({ preview: undefined });
			}

			readBuildingType(this.props.table.clicked_row).then(({ response }) => {
				this.setState({ preview: response.data });
			});
		}
	}

	render() {
		const { superadmin, application_language_id } = this.props;

		const columns = [
			{
				key: "id",
				name: "ID",
				width: 60,
				sortable: false
			},
			{
				key: "name",
				name: "Name",
				value: name => getLocalized(name, application_language_id)
			},
		];

		const singleActions = (building_type_id) => {
			return [
				<Tooltip text="Delete selected building type" key={_.uniqueId()}>
					<DeleteIcon
						onClick={e => {
							e.stopPropagation();

							showAlertbox({
								color: "red",
								title: __('general.alert.are-you-sure'),
								description: "Do you really want to delete the selected building type?\n\nThis process cannot be undone.",
								buttons: [
									{
										color: 'lightGray',
										text: __('general.alert.no-close'),
										onClick: 'close'
									},
									{
										color: 'gray',
										text: __('general.alert.yes-delete'),
										onClick: () => {
											deleteBuildingTypes([building_type_id]).then(() => {
												hideAlertbox();

												setNotification("The selected building type has been deleted.");
												listBuildingTypes();

												setTableParams('superadmin_building_types', {
													actioned_row: undefined
												});
											});
										},
									}
								]
							})
						}}
					/>
				</Tooltip>
			];
		};

		const groupActions = (building_types_ids) => [
			<Tooltip text="Delete selected building types" key={_.uniqueId()}>
				<DeleteIcon
					onClick={e => {
						e.stopPropagation();

						showAlertbox({
							color: "red",
							title: __('general.alert.are-you-sure'),
							description: "Do you really want to delete these building types?\n\nThis process cannot be undone.",
							buttons: [
								{
									color: 'lightGray',
									text: __('general.alert.no-close'),
									onClick: 'close'
								},
								{
									color: 'gray',
									text: __('general.alert.yes-delete'),
									onClick: () => {
										deleteBuildingTypes(building_types_ids).then(() => {
											hideAlertbox();

											setNotification("The selected building types have been deleted.");
											listBuildingTypes();

											setTableParams('superadmin_building_types', {
												selected_rows: []
											});
										});
									},
								}
							]
						})
					}}
				/>
			</Tooltip>
		];

		const preview = (
			<BuildingTypesFlyout
				data={this.state.preview}
				readAction={building_type_id => {
					return new Promise(resolve => {
						readBuildingType(getURLParam('id') || building_type_id).then(({ response }) => {
							this.setState({ preview: response.data });

							resolve(response);
						});
					});
				}}
			/>
		);

		return (
			<Table
				listAction={listBuildingTypes}
				name="superadmin_building_types"
				groupActions={superadmin.delete_building_type && groupActions}
				singleActions={superadmin.delete_building_type && singleActions}
				title={__("modules.submodules.title.building-types")}
				preview={this.state.preview ? preview : []}
				columns={columns}
			/>
		);
	}
}

export default BuildingTypes;
